import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable, of } from "rxjs";
import { map } from "rxjs/operators";
import { HubBasicGroupUser, HubUser } from "@appcore/models/user";
import { API } from "@service/system/api.service";
import { ColorUtility } from "@service/system/utilities.service";
import { AuthenticationService } from "@service/auth/authentication.service";
import { HttpManager } from "@service/system/httpManager.service";

const API_URL = API.API_URL;

export interface HubOrgCredentials {
  orgID: string;
  password: string;
}

@Injectable({ providedIn: "root" })
export class HubBasicGroupAuthenticationService implements AuthenticationService {
  currentUserSubject: BehaviorSubject<HubBasicGroupUser>;
  currentUser: Observable<HubBasicGroupUser>;
  $authed = new BehaviorSubject<boolean>(false);

  public adminRoleLevel = 1;

  constructor(private httpManager: HttpManager, private colorUtil: ColorUtility) {
    this.currentUserSubject = new BehaviorSubject<HubBasicGroupUser>(JSON.parse(sessionStorage.getItem("currentUser")));
    this.currentUser = this.currentUserSubject.asObservable();
  }

  public get currentUserValue(): any {
    const myUser: HubBasicGroupUser = <HubBasicGroupUser>this.currentUserValue;
    myUser.Initials = myUser.username.split(" ")[0].substring(0, 1) + myUser.username.split(" ")[1].substring(0, 1);
    myUser.ChipColor = this.colorUtil.colorStringToHSLHex(myUser.username);
    return myUser;
  }

  getCurrentUserValue(): Observable<HubUser> {
	return AuthenticationService.currentUserSubject;
  }

  async isAuthenticated(): Promise<boolean> {
    return !!(await of(this.currentUser != null));
  }

  //login(orgID: string, password: string) calls needs to be changed to login({orgID, password})
  login(credentials: HubOrgCredentials): Observable<any> {
    // return this.http.post<any>(`${config.apiUrl}/users/authenticate`, { username, password })
    const orgID = credentials.orgID;
    const password = credentials.password;

    return this.httpManager.httpPost<any>(API_URL + "/authorglogin", { orgID, password }).pipe(
      map(user => {
        // login successful if there's a jwt token in the response
        if (user && user.token) {
          // store user details and jwt token in local storage to keep user logged in between page refreshes
          sessionStorage.setItem("currentUser", JSON.stringify(user));
          this.currentUserSubject.next(user);
        }

        return user;
      })
    );
  }

  logout(): Observable<HubBasicGroupUser> {
    // remove user from local storage to log user out
    sessionStorage.removeItem("currentUser");
    this.currentUserSubject.next(null);
    return this.currentUser;
  }
}
